import { render, staticRenderFns } from "./bank-account.vue?vue&type=template&id=4b3b7b21&scoped=true&"
import script from "./bank-account.vue?vue&type=script&lang=js&"
export * from "./bank-account.vue?vue&type=script&lang=js&"
import style0 from "./bank-account.vue?vue&type=style&index=0&id=4b3b7b21&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3b7b21",
  null
  
)

export default component.exports